// import csvtojson from "csvtojson";
import _ from "lodash";
import gql from "graphql-tag";
import {
    computeAANames,
    getDefaultAccountableAccount,
} from "../../../backend/src/common/accountableAccount/accountableAccountServices";
import { cloneDeep } from "lodash";

import CREATE_ACCOUNTABLE_ACCOUNT from "../graphql/accountableAccount/CreateAccountableAccount.gql";
import { fillVatAccountableAccountAttributes } from "../../../backend/src/common/vat/vatServices";

// const accountableAccountTypes = ["Capital", "FixedAssets", "Stocks", "Purchase", "Sales", "ThirdParty", "Financial", "Special"];

export const socialAccountableAccounts = [
    "421000",
    "431000",
    // "433000",
    // "433500",
    // "433600",
    "442100",
    "437300",
    "437310",
    "437500",
    "437510",
    "437550",
    "437700",
    "437710",
    "437715",
    "437720",
    "437730",
];
export const stateAccountableAccounts = [
    "445500",
    "445510",
    "444000",
    "445800",
    "445810",
    "445820",
    "445830",
];

export const thirdParties = {
    user: "Utilisateur",
    bankAccount: "Compte Bancaire",
    thirdPartyCompany: "Société Tiers",
};

export const transactionTypes = {
    CASH: "Remise espèces",
    CHEQUE: "Remise chèques",
    CREDIT_CARD: "Remise cartes bleues",
    TRANSFER: "Remise virement",
    LUNCHEON_VOUCHER: "Remise tickets restaurant",
    HOLIDAY_VOUCHER: "Remise chèque vacances",
    PAYPAL: "Remise Paypal",
    DISTRIBUTION_PLATFORM: "Remise Plateforme",
    CREDIT_NOTES_ISSUED: "Remise - Avoirs émis",
    CREDIT_NOTES_RECOVERY: "Remise - Reprise d'avoirs",
    FREE: "Libre",
};

export const vatOperationTypes = {
    PURCHASE: "Achat",
    PURCHASE_FIXED_ASSET: "Achat d'immobilisation",
    SALE: "Vente",
};

export const vatTypes = {
    INTRACOM: "Intracom",
    INTRACOM_DEBIT: "Intracom débit",
    INTRACOM_CREDIT: "Intracom crédit",
    EXPORT: "Export",
    IMPORT: "Import",
    IMPORT_DEBIT: "Import débit",
    IMPORT_CREDIT: "Import crédit",
    REVERSE_CHARGE: "Autoliquidation",
    REVERSE_CHARGE_DEBIT: "Autoliquidation débit",
    REVERSE_CHARGE_CREDIT: "Autoliquidation crédit",
};

// export async function getAccountableAccounts(streamAsString: string) {
//     const accountableAccounts = {};
//     const partitions = {};
//     const genericTags = {};
//     const rows = await csvtojson().fromString(streamAsString);
//     for (const row of rows) {
//         analyseRow(partitions, accountableAccounts, row, genericTags);
//     }
//     return {
//         partitions,
//         accountableAccounts
//     }
// }

// function analyseRow(partitions, accountableAccounts, row, genericTags) {
//     const type = row.type;
//     if (!row.type) {
//         debugger;
//         return;
//     }
//     let accountableAccount = row.name;
//     if (!accountableAccount) {
//         debugger;
//         return;
//     }
//     accountableAccount = clearString(accountableAccount);
//     if (!accountableAccount) {
//         debugger;
//         return;
//     }
//     if (accountableAccounts[accountableAccount]) {
//         debugger;
//         return;
//     }
//     const description = clearString(row.description);
//     const shortDescription = clearString(row.shortDescription);
//     // description = "toto";
//     if (!description) {
//         debugger;
//         return;
//     }

//     if (accountableAccountTypes.indexOf(type) === -1) {
//         debugger;
//         return;
//     }
//     if (accountableAccounts[accountableAccount]) {
//         debugger;
//     }
//     let tag = accountableAccount;
//     let uniqueName = accountableAccount;

//     const isToDelete = clearString(row.delete) === 'X' ? true : false
//     const replaceAccountableAccount = clearString(row.replaceAccountableAccount)
//     const createSubAccount = clearString(row.createSubAccount)

//     if (row.default) {
//         tag = row.default;
//         tag = clearString(tag);
//         uniqueName = tag;
//         if (uniqueName === "Achat") {
//             uniqueName = "CT_Purchase";
//         } else if (uniqueName === "Vente") {
//             uniqueName = "CT_Sale";
//         }
//         if (!partitions.default) {
//             partitions.default = {
//                 name: "default",
//                 uniqueName: 'default',
//                 type: "AccountableAccount"
//             }
//         }
//         const aaDdta = {
//             type: type,
//             description: description,
//             shortDescription: shortDescription || row.default,
//             isToDelete: isToDelete,
//             replaceAccountableAccount: replaceAccountableAccount,
//             createSubAccount: createSubAccount,
//             tags: [
//                 {
//                     created: false,
//                     uniqueName: uniqueName,
//                     name: tag,
//                     partition: 'default',
//                     type: "AccountableAccount"
//                 }
//             ]
//         };
//         if (row.profitAndLoss) {
//             const tagName = clearString(row.profitAndLoss);
//             if (tagName.toLowerCase() !== "n/a") {
//                 if (!partitions.profitAndLoss) {
//                     partitions.profitAndLoss = {
//                         name: "Profit and Loss",
//                         uniqueName: 'profitAndLoss',
//                         type: "AccountableAccount"
//                     }
//                 }
//                 aaDdta.tags.push({
//                     created: false,
//                     uniqueName: tagName,
//                     name: tagName,
//                     partition: 'profitAndLoss',
//                     type: "AccountableAccount"
//                 })
//             }
//         }
//         if (row.fixedOrVariable) {
//             const tagName = clearString(row.fixedOrVariable);
//             if (tagName.toLowerCase() !== "n/a") {
//                 if (!partitions.fixedOrVariable) {
//                     partitions.fixedOrVariable = {
//                         name: "Fixe | Variable",
//                         uniqueName: 'fixedOrVariable',
//                         type: "AccountableAccount"
//                     }
//                 }
//                 const uniqueName = tagName === "Fixe" ? "Internal_Fixe" : tagName === "Variable" ? "Internal_Variable" : ""
//                 if (uniqueName) {
//                     aaDdta.tags.push({
//                         created: true,
//                         uniqueName: uniqueName,
//                         name: tagName,
//                         partition: 'fixedOrVariable',
//                         type: "Internal"
//                     })
//                 } else {
//                     debugger;
//                 }
//             }
//         }

//         if (row.generic) {
//             const tagName = clearString(row.generic);
//             if (tagName.toLowerCase() !== "n/a") {
//                 let partitionName;
//                 if (accountableAccount.startsWith("6")) {
//                     partitionName = 'genericPurchase';
//                     if (!partitions[partitionName]) {
//                         partitions[partitionName] = {
//                             name: "Tags Achats Génériques",
//                             uniqueName: partitionName,
//                             type: "Total",
//                             tags: []
//                         }
//                     }
//                 } else if (accountableAccount.startsWith("7")) {
//                     partitionName = 'genericSales';
//                     if (!partitions[partitionName]) {
//                         partitions[partitionName] = {
//                             name: "Tags Ventes Génériques",
//                             uniqueName: partitionName,
//                             type: "Total",
//                             tags: []
//                         }
//                     }
//                 } else {
//                     debugger
//                 }
//                 if (partitionName) {
//                     const uniqueName = "Internal_" + tagName.replace(/ /g, "");
//                     if (genericTags[uniqueName]) {
//                         debugger;
//                         throw new Error("Duplicate tag= " + uniqueName);
//                     }
//                     genericTags[uniqueName] = true;
//                     if (uniqueName) {
//                         partitions[partitionName].tags.push(uniqueName);
//                         aaDdta.tags.push({
//                             created: false,
//                             uniqueName: uniqueName,
//                             name: tagName,
//                             partition: partitionName,
//                             type: "Internal"
//                         })
//                     } else {
//                         debugger;
//                     }
//                 }
//             }
//         }
//         accountableAccounts[accountableAccount] = aaDdta;
//     } else {
//         debugger;
//     }
//     // let tag1 = tag;
//     // let uniqueName1 = uniqueName;
//     // if (row.restaurant) {
//     //     tag1 = row.restaurant;
//     //     tag1 = clearString(tag1);
//     //     uniqueName1 = tag1;
//     //     if (uniqueName1 === "Achat") {
//     //         uniqueName = "CT_Purchase";
//     //     } else if (uniqueName1 === "Vente") {
//     //         uniqueName = "CT_Sale";
//     //     }
//     // }
// }

// function clearString(original: string) {
//     let text = original;
//     text = text.replace(/^(\s{1,})/, '');
//     text = text.replace(/(\s{1,})$/, '');
//     text = text.replace(/(\s{2,})/g, ' ');
//     if (original !== text) {
//         console.error("space error")
//         console.error("original : |" + original + "|");
//         console.error("modified : |" + text + "|");
//     }
//     return text;
// }

export function padEndAAName(name, store, padEnd: boolean) {
    if (!name) {
        debugger;
        return name;
    }
    if (padEnd && name.length < store?.state?.accountableAccountTable.aaCharacterCount) {
        if (name.length === 3) {
            if (name === "511") {
                return name;
            }
            if (name.startsWith("70")) {
                return name;
            }
        }
        return name.padEnd(store?.state?.accountableAccountTable.aaCharacterCount, "0");
    }
    return name;
}

export function getAccountableAccount(store, aaName) {
    if (store) {
        const accountableAccount = store.state.accountableAccountTable.accountableAccounts.find(
            (aa) => aa.name === aaName,
        );
        return accountableAccount;
    } else {
        console.error("getAccountableAccount store is null");
        debugger;
    }
}

export async function getConnectAccountableAccount(
    store,
    apollo,
    inName: string,
    padEnd: boolean = true,
    inDescription: string = undefined,
    inLettering: boolean = undefined,
) {
    if (inName) {
        if (store?.state?.accountableAccountTable?.id) {
            const name = padEndAAName(inName, store, padEnd);
            let accountableAccount = getAccountableAccount(store, name);
            if (!accountableAccount) {
                const defautltAccountableAccount = await getDefaultAccountableAccount(inName);
                if (inLettering) {
                    defautltAccountableAccount.lettering = inLettering;
                }
                const accountableAccountData = cloneDeep(defautltAccountableAccount);
                accountableAccountData.name = name;

                if (inDescription) {
                    accountableAccountData.description = inDescription;
                }

                accountableAccount = await createAccountableAccount(
                    apollo,
                    store.state.accountableAccountTable.id,
                    accountableAccountData,
                );
                if (accountableAccount) {
                    store.state.accountableAccountTable.accountableAccounts.push(
                        accountableAccount,
                    );
                } else {
                    console.error("createAccountableAccount failed");
                    debugger;
                }
            }
            if (accountableAccount?.id) {
                // return {connect: {id:accountableAccount.id}}
                return {
                    connect: {
                        uniqueName: {
                            name,
                            accountableAccountTableId: store.state.accountableAccountTable.id,
                        },
                    },
                };
            }
        } else {
            console.error("accountableAccountTable undefined");
            debugger;
        }
    } else {
        console.error("inName null");
    }
    debugger;
    return undefined;
}

export async function createAccountableAccount(
    apollo,
    accountableAccountTableId,
    accountableAccount,
) {
    // let name = accountableAccount.name
    // if (padEnd) {
    //     if (accountableAccount.name.length >= 6 && accountableAccount.name.length < accountableAccountTable.aaCharacterCount) {
    //         name = accountableAccount.name.padEnd(accountableAccountTable.aaCharacterCount, "0")
    //     }
    // }
    if (accountableAccount.name.startsWith("445")) {
        fillVatAccountableAccountAttributes(accountableAccount);
    }
    const data = {
        accountableAccountTableId: accountableAccountTableId,
        type: accountableAccount.type,
        name: accountableAccount.name,
        description: accountableAccount.description,
        shortDescription: accountableAccount.shortDescription || null,
        name1: undefined,
        name2: undefined,
        name3: undefined,
        name4: undefined,
        name5: undefined,
        name6: undefined,
        lettering: accountableAccount.lettering,
        detailedCarryForward: accountableAccount.detailedCarryForward,
        vatRate: accountableAccount.vatRate,
        vatType: accountableAccount.vatType,
        vatOperationType: accountableAccount.vatOperationType,
        user: accountableAccount.user,
        thirdPartyCompany: accountableAccount.thirdPartyCompany,
        bankAccount: accountableAccount.bankAccount,
    };
    computeAANames(accountableAccount.name, data);
    const result = await apollo.mutate({
        mutation: CREATE_ACCOUNTABLE_ACCOUNT,
        variables: data,
    });
    return result.data.createAccountableAccount;
}

export function getAccountableAccountComplementInfo(aa, lettering) {
    const complement = [];
    if (aa.lettering && lettering) {
        complement.push("À lettrer");
    }

    if (aa.user) {
        complement.push(thirdParties.user);
    } else if (aa.bankAccount) {
        complement.push(thirdParties.bankAccount);
    } else if (aa.thirdPartyCompany) {
        complement.push(thirdParties.thirdPartyCompany);
    }

    if (aa.transactionType) {
        let transactionText = aa.transactionType ? transactionTypes[aa.transactionType] : "";
        if (aa.default) {
            transactionText = transactionText.replace(/^/, "Par défaut - ");
        }
        complement.push(transactionText);
    }

    if (aa.vatOperationType || aa.vatRate || aa.vatType) {
        if (aa && aa.name && (aa.name.startsWith("70") || aa.name.startsWith("445"))) {
            if (aa.name.length === 3) {
                return "";
            }
            let vatText = "TVA";
            if (aa) {
                if (aa.vatRate) {
                    vatText += ` - ${aa.vatRate} %`;
                }
                if (aa.vatOperationType) {
                    vatText += " - " + vatOperationTypes[aa.vatOperationType] || "";
                }
                if (aa.vatType && aa.vatType !== "NO_VAT_TYPE") {
                    vatText += " - " + vatTypes[aa.vatType] || "";
                }
            }
            complement.push(vatText);
        }
    }

    if (aa.paidAndUncashed) {
        // complement.push("Payé et non encaissé");
    }

    if (aa.publish) {
        complement.push("Publié");
    }
    return complement;
}

export async function showThirdPartyCompanyOrBankAccountOrUser(aaId, apollo) {
    const toShow = {
        thirdPartyCompanyToShow: false,
        bankAccountToShow: false,
        userToShow: false,
    }
    if (aaId) {
        debugger
        const aa2: any = await apollo.query({
            query: gql`
                query (
                    $id: ID!
                ) {
                    accountableAccounts(
                        where: {
                            id: $id
                        }
                    ) {
                        id
                        
                        bankAccount
                        thirdPartyCompany
                        user
                    }
                }
            `,
            variables: {
                id: aaId
            },
        });

        if (aa2?.data?.accountableAccounts?.length) {
            const aa = aa2.data.accountableAccounts[0];
            if (aa?.user) {
                toShow.userToShow = true;
                return toShow;
            }
            if (aa?.thirdPartyCompany) {
                toShow.thirdPartyCompanyToShow = true;
                return toShow;
            }
            if (aa?.bankaccount) {
                toShow.bankAccountToShow = true;
                return toShow;
            }
        }
    }
    return toShow;
}
